export const environment = {
  name: {
    short: 'dev',
    long: 'dev'
  },
  analytics: {
    google: 'UA-112169318-4'
  },
  production: false,
  tokenName: 'token_msc_staging',
  tokenSessionName: 'token_session',
  refreshTokenName: 'refresh_token_staging',
  domain: 'deltablue.com',
  envVar: {
    MSC_APP_URL: 'https://app.myskillcamp.com.deltabluecdn.com/',
      API_URL: "https://api-upgraded.myskillcamp.com.deltabluecdn.com/api",
      AUTHENTICATION_API_URL: "https://auth.myskillcamp.com.deltabluecdn.com",
      API_STOCKAGE_URL: "https://api-upgraded.myskillcamp.com.deltabluecdn.com/api/stockage/",
      REPORTING_URL: "https://newreportinguat-5c8170cb08ac.deltablue.io/api/v2",
      STUDIO_URL: "https://studio.myskillcamp.com.deltabluecdn.com/",
      PLAYER_URL: "https://player.myskillcamp.com.deltabluecdn.com/",
      AUTHORIZATION_SERVER_URL: "https://cloud.myskillcamp.com.deltabluecdn.com"
}
};